import React, { createContext, useContext, useState, useEffect } from 'react';
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signInAnonymously,
  signOut, 
  onAuthStateChanged,
  updateEmail,
  EmailAuthProvider,
  reauthenticateWithCredential
} from 'firebase/auth';
import { auth } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  function signup(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function loginAnonymously() {
    return signInAnonymously(auth);
  }

  function logout() {
    return signOut(auth);
  }

  async function updateUserEmail(newEmail, password) {
    if (!currentUser || !currentUser.email) {
      throw new Error('No user signed in');
    }

    // Create credential for re-authentication
    const credential = EmailAuthProvider.credential(currentUser.email, password);
    
    // Re-authenticate user
    await reauthenticateWithCredential(currentUser, credential);
    
    // Update email
    await updateEmail(currentUser, newEmail);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    login,
    signup,
    loginAnonymously,
    logout,
    updateUserEmail
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}